import { mapActions, mapGetters, mapState } from "vuex";
import { pluralCount } from "@/helpers/helpers";
import { DialogHelper } from "@/helpers/dialog-helper";
import AlertDialog from "@/components/ui/AlertDialog";
import { GTM_EVENT_NAME } from "@/enums/gtm-events";

export default {
  components: {
    AlertDialog
  },
  computed: {
    ...mapState({
      rejectInProgress: state => state.externalChanges.loading
    }),
    ...mapGetters({
      count: "externalChanges/changesCount",
      facilitiesCount: "externalChanges/changesFacilitiesCount",
      changesFields: "externalChanges/changesFields"
    }),
    changesCountLabel() {
      return pluralCount("message.pluralForms.changeAccusative", this.count);
    },
    facilitiesCountLabel() {
      return pluralCount(
        "message.pluralForms.facilityLocative",
        this.facilitiesCount
      );
    },
    fieldsLabel() {
      return this.changesFields.map(i => i.toLowerCase()).join(", ");
    }
  },
  methods: {
    ...mapActions({
      fetchProtectionSummary: "externalChanges/fetchProtectionSummary",
      rejectChanges: "externalChanges/rejectChanges"
    }),
    confirmRejection() {
      DialogHelper.showConfirmDialog(
        {
          text: this.$t(
            "message.externalChanges.changesInfoSection.rejectConfirmation",
            {
              changesCount: this.changesCountLabel,
              facilitiesCount: this.facilitiesCountLabel
            }
          ),
          okLabelKey: "message.common.yes",
          cancelLabelKey: "message.common.no"
        },
        () => {
          this.rejectAndConfirm();
        }
      );
    },
    async rejectAndConfirm(rejectCallback) {
      const rejected = await this.rejectChanges();
      if (rejected) {
        this.$gtm.trackCustomEvent({
          event: GTM_EVENT_NAME.EXTERNAL_CHANGES_PROTECT_CONFIRM
        });
        if (rejectCallback) {
          rejectCallback();
        }
        DialogHelper.showDialog(
          AlertDialog,
          {
            text: this.$t(
              "message.externalChanges.changesInfoSection.rejectingDialog"
            ),
            buttonText: this.$t("message.common.ok")
          },
          [
            {
              event: "close",
              callback: () => {
                this.fetchProtectionSummary();
              }
            }
          ]
        );
      }
    }
  }
};
